/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `easy` - Łatwy
 * * `medium` - Średni
 * * `hard` - Trudny
 */
export type QuizDifficultyEnum = typeof QuizDifficultyEnum[keyof typeof QuizDifficultyEnum];


export const QuizDifficultyEnum = {
  easy: 'easy',
  medium: 'medium',
  hard: 'hard',
} as const;
